export default class Settings{

    static websocketAvallible() {
        if (process.env.VUE_APP_WEBSOCKET_URL) {
            return true
        }
        return false
    }

    static displayLangBar() {
        return process.env.VUE_APP_LANG_BAR
    }

    static displayTestInfo() {
        return process.env.VUE_APP_TEST_INFO == 'true'
    }

    static displayTest() {
        return process.env.VUE_APP_TEST == 'true'
    }

    static displayDashboard() {
        if (process.env.VUE_APP_DASHBOARD === "false") {
            return false
        }
        return true
    }

    static getEntrypoint() {
        return process.env.VUE_APP_ENTRYPOINT ? process.env.VUE_APP_ENTRYPOINT : 'dashboard'
    }

    static hiddenSchemaForWorker() {
        if (process.env.VUE_APP_HIDDEN_SCHEMAS_FOR_WORKER == "true") {
            return true
        }
        return false
    }

    static folderAvallible() { //Default true
        if (process.env.VUE_APP_FOLDER === "false") {
            return false
        }
        return true
    }

    static relationalSchemaAvallible() {
        if (process.env.VUE_APP_RELATIONAL_SCHEMA === "false") {
            return false
        }
        return true
    }

    static documentAvallible() {
        if (process.env.VUE_APP_DOCUMENT === "true") {
            return true
        }
        return false
    }

    static generateNewPasswordAvallible() {
        if (process.env.VUE_APP_GENERATE_NEW_PASSWORD === "true") {
            return true
        }
        return false
    }

    static deleteUserEnable() {
        if (process.env.VUE_APP_DELETE_USER === "true") {
            return true
        }
        return false
    }

    static appName() {
        if (process.env.VUE_APP_NAME) {
            return process.env.VUE_APP_NAME
        }
        return "2Form"
    }

    static moduleUserFileName() {
        if (process.env.VUE_APP_MODULE_USER_FILE_NAME) {
            return process.env.VUE_APP_MODULE_USER_FILE_NAME
        }
        return "Pliki uzytkownika"
    }

    static moduleWorkerDocumentName() {
        if (process.env.VUE_APP_MODULE_WORKER_DOCUMENT_NAME) {
            return process.env.VUE_APP_MODULE_WORKER_DOCUMENT_NAME
        }
        return "Dokumenty pracowników"
    }

}